import React from 'react';
import {
  boxShadow,
  percent,
  px,
} from '@packages/systems/core/utils/WebflowCssSubset';
import View from '../View';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_CART_CONTAINER,
} from '@packages/systems/commerce/constants';

const config = createIntegratedAtom({
  displayName: 'Cart Container',
  showEmpty: true,
  constraints: {
    pinToParent: true,
    descendants: [
      {is: 'CommerceCartHeader', rule: 'ExactlyOne'},
      {is: 'CommerceCartFormWrapper', rule: 'ExactlyOne'},
    ],
  },
  lockedStyles: {
    position: {
      when: true,
      message: 'The cart wrapper position can’t be changed.',
    },
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          width: percent(100),
          maxWidth: px(480),
          minWidth: px(320),
          flexDirection: 'column',
          overflow: 'auto',
          backgroundColor: createRgbaColor('fff'),
          boxShadow: boxShadow({
            xOffset: px(0),
            yOffset: px(5),
            blurRadius: px(25),
            spreadRadius: px(0),
            color: createRgbaColor({r: 0, g: 0, b: 0, a: 0.25}),
          }),
        },
      },
    },
  },
  // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
  render: (props) => {
    const newAttributes = props.attributes
      .set(DATA_ATTR_NODE_TYPE, NODE_TYPE_COMMERCE_CART_CONTAINER)
      .set('role', 'dialog');

    return <View {...props} attributes={newAttributes} />;
  },
  fields: {
    children: TListOfElement,
  },
});

export default config;
